import Highlight from 'components/Highlight';
import './AcrisLinks.css';

const EMPTY_LOT_UNIT_PLACEHOLDER = '—';
const LIST_SEPARATOR = ', ';
const LOT_UNIT_SEPARATOR = ' / ';

/**
 * Renders ACRIS lot and unit lists as "lot / unit", omitting whichever side is empty.
 */
function AcrisLotUnit(props) {
	const { rowData, searchString } = props;
	const lots = listValues(rowData?.lots);
	const units = listValues(rowData?.units);
	const parts = [];

	if (lots.length > 0) {
		parts.push(lots.join(LIST_SEPARATOR));
	}
	if (units.length > 0) {
		parts.push(units.join(LIST_SEPARATOR));
	}

	if (parts.length === 0) {
		return <span className="acris-lot-unit-empty">{EMPTY_LOT_UNIT_PLACEHOLDER}</span>;
	}

	const display = parts.join(LOT_UNIT_SEPARATOR);

	return (
		<span className="acris-lot-unit">
			<Highlight text={display} substring={searchString} />
		</span>
	);
}

function listValues(value) {
	if (!Array.isArray(value)) {
		return [];
	}

	return value
		.map((item) => (item === null || item === undefined ? '' : String(item).trim()))
		.filter(Boolean);
}

export default AcrisLotUnit;
